import { i18n } from '../i18n';

import { CouponType, ExpireType } from '@tencent/wphk-act-base-types';
import dayjs from 'dayjs';

/** 是否商户展示券 */
export function checkIsSpCoupon(couponType?: CouponType): boolean {
  // 三种商户展示券类型
  return !!couponType && [
    CouponType.SPCOUOPN,
    CouponType.SPCOUOPN_CDKEY,
    CouponType.SPCOUOPN_ONECDKEY,
  ].includes(couponType);
}

/** 获取有效期限 */
export function getValidPeriod(coupon): string {
  if (!coupon) return '';
  const { expireType, validTime, expireTime, expireDay } = coupon;
  if (expireType === ExpireType.FIXED) {
    return `${dayjs(validTime).format('YYYY.MM.DD')} - ${dayjs(expireTime).format('YYYY.MM.DD')}`;
  }
  return i18n('領取後x天内有效', { expireDay });
};
